import {getValueForBreakpoint} from '../utils/breakpoint-util';
import pubsub from '../utils/pubsub';
import screenUtil from '../utils/screen';
import {
	getValueFromThreshold,
	isValidThresholdValue
} from '../utils/threshold-util';

const DEFAULT_LAZYLOAD_THRESHOLD = 300;

let lazyLoadThreshold = DEFAULT_LAZYLOAD_THRESHOLD,
	waitingForInView = [];

pubsub.subscribe('scroll', _resolveInViewSlots);

function init(/** Settings */ settings) {
	lazyLoadThreshold = settings.lazyLoadThreshold;
	waitingForInView = [];
}

function waitForSlot(/** Slot */ slot) {
	if (!getValueForBreakpoint(slot.lazyLoad)) {
		return Promise.resolve(slot);
	}

	return new Promise((resolve) => {
		if (_isInView(slot)) {
			resolve(slot);
		} else {
			waitingForInView.push({
				slot,
				resolve
			});
		}
	});
}

function _isInView(slot) {
	const threshold = _getThresholdForSlot(slot);

	return screenUtil.isInView(slot.node, threshold);
}

function _getThresholdForSlot(/** Slot */ slot) {
	let thresholdValue = getValueFromThreshold(slot.lazyLoadThreshold);

	if (!isValidThresholdValue(thresholdValue)) {
		thresholdValue = getValueFromThreshold(lazyLoadThreshold);
	}

	if (!isValidThresholdValue(thresholdValue)) {
		thresholdValue = DEFAULT_LAZYLOAD_THRESHOLD;
	}

	return typeof thresholdValue === 'string' ? screenUtil.getScreenRatioValue(thresholdValue) : thresholdValue;
}

function _resolveInViewSlots() {
	waitingForInView = waitingForInView.filter(({
		                                            slot,
		                                            resolve
	                                            }) => {
		if (_isInView(slot)) {
			resolve(slot);

			return false;
		}

		return true;
	});
}

export default {
	init,
	waitForSlot
};
